import { Component, ElementRef, EventEmitter, Output, Renderer2, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoginService } from '../login/service/login.service';
import { NotifierService } from 'angular-notifier';
import validationform from '../../validation/validationform';
import Validation from '../../validation/confirm-password-validation';
import * as CryptoJS from 'crypto-js';
@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  spinner:boolean=false;
  otpInput: any;
  getEmailVerifyResponseData: any;
  otpVerifiedData: any = [];
  submitted:boolean=false;
  isText = false;
  type: string = 'password';
  eyeIcon = 'fa-eye-slash';
  passwordIcon = 'fa fa-lock';
  forgotPasswordForm: FormGroup = new FormGroup({});
  showVerifyForm:string="forgotPassword";
  passwordForm: FormGroup = new FormGroup({});
   otpForm:FormGroup = new FormGroup({});
  postData = {
    email: '',
    encrypted_data: '',
    pass_phrase: "6389U%$B*P*-'TD5",
    salt: "`W/Q`,1/N.CG'%3I",
  };

  otpFormSubmit:boolean=false;


  @ViewChild('verifyOTP') verifyOTP!:ElementRef;
  @ViewChild('verifyOTPError') verifyOTPError!:ElementRef;
  @ViewChild('verifyOTPBtn') verifyOTPBtn!:ElementRef;

  @Output() formChange:EventEmitter<any>=new EventEmitter();

  private readonly notifier: NotifierService;
  
  constructor(private formBuilder: FormBuilder,private service:LoginService,private notifierService: NotifierService,private renderer:Renderer2){
    this.notifier = notifierService;
  }

  ngOnInit(){
    this.forgotPasswordForm = this.formBuilder.group({
      email: [null, [Validators.required,Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]],
    });
    this.passwordForm = this.formBuilder.group(
      {
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(40),
            Validators.pattern(
              '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{7,}'
            ),
          ],
        ],
        confirmPassword: ['', Validators.required],
      },
      {
        validators: [Validation.match('password', 'confirmPassword')],
      }
    );

    this.otpForm = this.formBuilder.group({
       userOTP:['',[Validators.required,Validators.pattern('^[0-9]*$')]]
    });
  }

  get f(): { [key: string]: AbstractControl } {
    return this.passwordForm.controls;
  }


  get verifyValidate() {
    return this.otpForm.controls;
  }

  submitOtp() {
    this.spinner = true;
    this.otpFormSubmit=true;
    const otpPayload = {
      is2fa: this.getEmailVerifyResponseData?.is2faenabled ? true : false,
      verifyotp: this.otpForm.value['userOTP'].toString().trim(),
    };

    this.service.postOtp(otpPayload).subscribe({
      next: (response) => {
        this.otpVerifiedData = response;
        const token = this.otpVerifiedData.token;
        const userid = this.otpVerifiedData.userid;
        localStorage.setItem('loginuser', userid);
        sessionStorage.setItem('token', token);
         this.showVerifyForm = 'otp';
         this.spinner = false;
      },
      error: (err) => {
        this.spinner = false;
      },
    });
  }


  hideShowPassword() {
    this.isText = !this.isText;
    this.isText ? (this.eyeIcon = 'fa-eye') : (this.eyeIcon = 'fa-eye-slash');
    this.isText ? (this.type = 'text') : (this.type = 'password');
  }


  forgotPasswordFun() {
    this.spinner = true;
    if (this.forgotPasswordForm.valid) {
      this.service
        .forgotPasswordRest(this.forgotPasswordForm.controls['email'].value)
        .subscribe({
          next: (respone:any) => {
            this.spinner = false;
            this.notifier.notify(
              'default', "A verification PIN has been sent to your email."
            );
            this.showVerifyForm = 'verify';
        // this.verifyOTPFormValidate();
          
          },
          error: (err) => {
            this.spinner = false;
          },
        });
    } else {
      validationform.ValidateAllFormFields(this.forgotPasswordForm);
    }
  }


  onSubmit(): void {
    this.submitted = true;
    if (this.passwordForm.invalid) {
      return;
    }
    const values = this.passwordForm.value;
    const email = localStorage.getItem('loginuser');
    const password = values.password;
    const possible =  "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890,./;'[]=-)(*&^%$#@!~`";
    const dynamic_str = this.makeRandom(16, possible);
    const salt = this.makeRandom(16, possible);
    const iterations = 128;
    const bytes = CryptoJS.PBKDF2(dynamic_str, salt, {
      keySize: 48,
      iterations: iterations,
    });
    const iv = CryptoJS.enc.Hex.parse(bytes.toString().slice(0, 32));
    const key = CryptoJS.enc.Hex.parse(bytes.toString().slice(32, 96));

    const ciphertext = CryptoJS.AES.encrypt(password, key, { iv: iv });
    const formEncript = {
      email: email,
      encrypted_data: ciphertext.toString(),
      salt: salt,
      pass_phrase: dynamic_str,
    };
    
    this.spinner = true;
    this.service.postPassword(formEncript).subscribe({
      next: (response:any) => {
        this.showVerifyForm = 'passwordSuccess';
        this.notifier.notify('default',response['result']);
        this.spinner = false;
        this.submitted = false;
        this.isText = false;
      },
      error: (err) => {
        console.log(err);
        this.spinner = false;
      },
    });
  }


  makeRandom(lengthOfCode: number, possible: string) {
    let text = '';
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }


  verifyOTPFormValidate(){
    this.renderer.setStyle(this.verifyOTPError.nativeElement,'display','none');
    this.renderer.setAttribute(this.verifyOTPBtn.nativeElement,'disabled','true');
    this.renderer.listen(this.verifyOTP.nativeElement,'input',(event:any)=>{
      let pattern = /^[0-9]\d*$/;
      let inputvalue:any = event.target.value;
      if(!pattern.test(inputvalue)){
        this.renderer.setStyle(this.verifyOTPError.nativeElement,'display','block');
        this.renderer.setAttribute(this.verifyOTPBtn.nativeElement,'disabled','true');
        setTimeout(()=>{
          this.verifyOTP.nativeElement.value="";
        },1500);
        
      }else{
        this.renderer.setStyle(this.verifyOTPError.nativeElement,'display','none');
        this.renderer.removeAttribute(this.verifyOTPBtn.nativeElement,'disabled');
      }
   });
  }


  goBack(){
   this.formChange.emit('login');
  }

}
